import baseApi from "./baseApi"

export default {
    async getMasterData(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/rejection/getMasterData?" + [
            "PlantID=" + plantID
        ].join("&"));
        return result.data;
    },

    async getSessions(plantID, date, teamID, locationID, varietyID, barcode) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/rejection/getSessions?" + [
            "PlantID=" + plantID,
            "Date=" + date,
            "Barcode=" + (barcode == null ? '' : barcode),
            "TeamID=" + teamID,
            "LocationID=" + locationID,
            "VarietyID=" + varietyID
        ].join("&"));
        return result.data;
    },

    async updateRejectedPunnets(sessions) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/rejection/updateRejectedPunnets", sessions);
        return result.data;
    },
    async exportToCSV(plantID, date, teamID, locationID, varietyID, barcode) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/rejection/exportToCSV?" + [
            "PlantID=" + plantID,
            "Date=" + date,
            "Barcode=" + barcode,
            "TeamID=" + teamID,
            "LocationID=" + locationID,
            "VarietyID=" + varietyID
        ].join("&"));

        let url = window.URL.createObjectURL(new Blob([result.data]));
        let link = document.createElement("a");
        link.href = url;
        let contentDisposition = result.headers["content-disposition"];
        let fileName = 'unknown';
        if (contentDisposition) {
            let fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch.length === 2) {
                fileName = fileNameMatch[1];
            }
        }
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
}